import React from "react";
import EditUser from "../components/ui/edit-user";

const EditUserPage = () => {
  return <EditUser />;
};

export default EditUserPage;
